// //diwaker code

// 'use client';
// import React from 'react';
// import { useState, useContext, useEffect, useRef, useMemo } from 'react';
// import { Buttons } from '../../../../components/ui/button';
// import { Badge } from '../../../../components/ui/badge';
// import {
//   Tabs,
//   TabsList,
//   TabsTrigger,
//   TabsContent,
// } from '../../../../components/ui/tabs';
// import BtnClickSound from '../../../../assets/adiuo/simple-btn-click.mp3';
// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableHead,
//   TableHeader,
//   TableRow,
// } from '../../../../components/ui/table';
// import { ChevronLeft, ChevronRight } from 'lucide-react';
// import svgPaths from '../../../../imports/svg-knollny4nu';
// import {
//   CustomCoinIcon,
//   CustomHomeIcon,
//   CustomMapIcon,
//   CustomRankingIcon,
//   CustomSettingsIcon,
// } from '../../../../components/ui/CustomIcons';
// // import imgBackground from "/images/background.png";
// import { useColor } from '../../../../components/ui/ColorContext';
// import ColorPicker from '../../../../components/ui/ColorPicker';
// import { Slider } from '../../../../components/ui/slider';
// import {
//   Dialog,
//   DialogContent,
//   DialogTrigger,
// } from '../../../../components/ui/dialog';
// // import { ReplayDialog } from "./ReplayDialog";
// import { motion } from 'framer-motion';
// import { getLeaderboardData } from 'utils/gameApplication/gamePlayService';
// import { useParams } from 'react-router-dom';

// // Helper function to convert hex to RGB
// const hexToRgb = (hex: string): string => {
//   const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
//   if (!result) return '0, 255, 187'; // fallback to default green
//   const r = Number.parseInt(result[1], 16);
//   const g = Number.parseInt(result[2], 16);
//   const b = Number.parseInt(result[3], 16);
//   return `${r}, ${g}, ${b}`;
// };

// // Moved NavigationArrow outside to prevent recreation
// const NavigationArrow: React.FC<{
//   direction: 'left' | 'right';
//   onClick: () => void;
//   primaryColor: string;
// }> = React.memo(({ direction, onClick, primaryColor }) => {
//   const primaryColorRgb = hexToRgb(primaryColor);

//   return (
//     <Buttons
//       variant="ghost"
//       size="sm"
//       onClick={onClick}
//       className="h-10 w-[3.75rem] rounded-3xl px-4 py-2 transition-all duration-200 hover:scale-110"
//       style={{
//         background: `linear-gradient(${
//           direction === 'left' ? '275.041deg' : '90deg'
//         },
//               rgba(${primaryColorRgb}, 0.6) 7.25%, rgba(${primaryColorRgb}, 0.15) 84.803%)`,
//         border: `1px solid ${primaryColor}`,
//         boxShadow: `0px 0px 15.9542px 0px rgba(${primaryColorRgb}, 0.3)`,
//       }}
//     >
//       {direction === 'left' ? (
//         <ChevronLeft className="!h-4 !w-4 text-white" />
//       ) : (
//         <ChevronRight className="!h-4 !w-4 text-white" />
//       )}
//     </Buttons>
//   );
// });

// const LeaderBoardFutureTheme: React.FC<{
//   onNavigate?: (direction: 'left' | 'right') => void;
//   formData?: any;
//   playMenuSound: () => void;
//   imageSrc?: any;
//   getData?: any;
//   data?: any;
//   homeLeaderBoard?: any;
//   setHomeLeaderBoard?: any;
//   setCurrentScreenId?: any;
//   currentScreenId?: any;
//   gameInfo?: any;
//   preloadedAssets: any;
//   setPlayerTodayScore: any;
//   playerTodayScore: any;
//   setCurrentQuestNo: any;
//   setFirstLoading: any;
//   learnerPlayList: any;
//   profile?: any;
//   setProfile?: any;
//   useData?: any;
// }> = React.memo(
//   ({
//     onNavigate,
//     formData,
//     imageSrc,
//     getData,
//     data,
//     setCurrentScreenId,
//     currentScreenId,
//     homeLeaderBoard,
//     setHomeLeaderBoard,
//     gameInfo,
//     preloadedAssets,
//     setPlayerTodayScore,
//     playerTodayScore,
//     setCurrentQuestNo,
//     setFirstLoading,
//     learnerPlayList,
//     profile,
//     playMenuSound,
//     setProfile,
//     useData,
//   }) => {
//     const playClickSound = () => {
//       try {
//         const audio = new Audio(BtnClickSound as string);
//         audio.volume = 1;
//         audio.play().catch(() => {});

//         setTimeout(() => {
//           audio.pause();
//           audio.currentTime = 0;
//         }, 1000);
//       } catch (e) {
//         // ignore audio errors
//       }
//     };

//     const { primaryColor } = useColor();
//     const primaryColorRgb = useMemo(
//       () => hexToRgb(primaryColor),
//       [primaryColor],
//     );

//     const [selectedTab, setSelectedTab] = useState<'department' | 'overall'>(
//       'overall',
//     );
//     const [isReplayDialogOpen, setIsReplayDialogOpen] = useState(false);
//     const { learner_game_play_id } = useParams();

//     // State from original component
//     const [shuffledUsers, setShuffledUsers] = useState<any[]>([]);
//     const [allTimeClicked, setAllTimeClicked] = useState(false);
//     const [newSortedUserss, setNewSortedUserss] = useState<any[]>([]);
//     const [sortedUsers, setSortedUsers] = useState<any[]>([]);
//     const [sortAse, setSortAse] = useState({ daily: true, allTime: true });
//     const [departmentLeaderboardData, setDepartmentLeaderboardData] = useState<
//       any[]
//     >([]);
//     const [companyLeaderboardData, setCompanyLeaderboardData] = useState<any[]>(
//       [],
//     );

//     const containerRef = useRef<any>(null);
//     let lastScrollTop = 0;

//     const hasFetchedRef = useRef(false);
//     useEffect(() => {
//       if (currentScreenId !== 4) return;

//       if (!learner_game_play_id || hasFetchedRef.current) return;

//       const getAllLearnerScores = async () => {
//         const getLeaderboardDatas = await getLeaderboardData(
//           learner_game_play_id,
//         );

//         if (getLeaderboardDatas?.departmentLeaderboardData) {
//           setDepartmentLeaderboardData(
//             getLeaderboardDatas.departmentLeaderboardData,
//           );
//         }

//         if (getLeaderboardDatas?.companyLeaderboardData) {
//           setCompanyLeaderboardData(getLeaderboardDatas.companyLeaderboardData);
//         }
//       };

//       getAllLearnerScores();

//       hasFetchedRef.current = true;
//     }, [learner_game_play_id]);

//     // Calculate player today score
//     useEffect(() => {
//       const currentDate = new Date();
//       const day = String(currentDate.getDate()).padStart(2, '0');
//       const month = String(currentDate.getMonth() + 1).padStart(2, '0');
//       const year = currentDate.getFullYear();
//       const formattedDate = `${day}-${month}-${year}`;

//       const scores = profile?.score;
//       const sums: any = {};
//       scores?.forEach((score: any) => {
//         const quest = score.quest;
//         if (!sums[quest]) {
//           sums[quest] = 0;
//         }
//         if (score.scoreEarnedDate === formattedDate) {
//           sums[quest] += score.score;
//         }
//       });

//       let getFinalscores = {};
//       Object.entries(sums).forEach(([quest, score]) => {
//         const IntQuest = parseInt(quest);
//         const newQuest = { ...getFinalscores, [IntQuest]: score };
//         getFinalscores = { ...newQuest };
//       });

//       const Replayscores =
//         profile?.replayScore?.length > 0 ? profile?.replayScore : null;
//       const Replaysums: { [key: number]: number } = {};
//       Replayscores?.forEach((score: any) => {
//         const quest = score.quest;
//         if (!Replaysums[quest]) {
//           Replaysums[quest] = 0;
//         }
//         if (score.scoreEarnedDate === formattedDate) {
//           Replaysums[quest] += score.score;
//         }
//       });

//       let getReplayFinalscores: { [key: number]: number } = {};
//       Object.entries(Replaysums).forEach(([quest, score]) => {
//         const IntQuest = parseInt(quest);
//         getReplayFinalscores = { ...getReplayFinalscores, [IntQuest]: score };
//       });

//       const TodayTotalScore = Object.entries(getFinalscores).reduce(
//         (tot: number, acc: any) => {
//           let questNo = acc[0];
//           let questHasReplay = Object.keys(getReplayFinalscores).some(
//             (quest) => quest === questNo,
//           );
//           if (questHasReplay) {
//             getReplayFinalscores[questNo] > acc[1]
//               ? (tot += getReplayFinalscores[questNo])
//               : (tot += acc[1]);
//           } else {
//             tot += acc[1];
//           }
//           return tot;
//         },
//         0,
//       );
//       setPlayerTodayScore(TodayTotalScore);
//     }, [playerTodayScore, profile, setPlayerTodayScore]);

//     // Process leaderboard data
//     const leaderboardToRender = useMemo(() => {
//       const currentBoard =
//         selectedTab === 'department'
//           ? departmentLeaderboardData
//           : companyLeaderboardData;
//       const data = Array.isArray(currentBoard) ? currentBoard.slice() : [];

//       // Map scores to positions (daily)
//       const dailySorted = data
//         .slice()
//         .sort((a, b) => (b.score ?? 0) - (a.score ?? 0));
//       const dailyPos = new Map<number | string, number>();
//       dailySorted.forEach((item, idx) => {
//         const key = item.learnerId ?? item.name ?? idx;
//         dailyPos.set(key, idx + 1);
//       });

//       // Map allTimeScore to positions (all time)
//       const alltimeSorted = data
//         .slice()
//         .sort((a, b) => (b.allTimeScore ?? 0) - (a.allTimeScore ?? 0));
//       const alltimePos = new Map<number | string, number>();
//       alltimeSorted.forEach((item, idx) => {
//         const key = item.learnerId ?? item.name ?? idx;
//         alltimePos.set(key, idx + 1);
//       });

//       // Attach positions
//       const augmented = data.map((item, idx) => {
//         const key = item.learnerId ?? item.name ?? idx;
//         return {
//           ...item,
//           dailyPosition: dailyPos.get(key) ?? idx + 1,
//           alltimePosition: alltimePos.get(key) ?? idx + 1,
//         };
//       });

//       // Order by daily score for display (highest first)
//       const ordered = augmented
//         .slice()
//         .sort((a, b) => (b.score ?? 0) - (a.score ?? 0));

//       // If you want the currently-playing user to appear visually at the top,
//       // find them and move their row to index 0 (positions remain unchanged).
//       const playerName =
//         learnerPlayList?.LearnerProfile?.nickName ??
//         learnerPlayList?.LearnerProfile?.name;
//       if (playerName) {
//         const playerIndex = ordered.findIndex((it) => it.name === playerName);
//         if (playerIndex > -1) {
//           const [playerRow] = ordered.splice(playerIndex, 1);
//           ordered.unshift(playerRow);
//         }
//       }

//       return ordered;
//     }, [
//       selectedTab,
//       departmentLeaderboardData,
//       companyLeaderboardData,
//       learnerPlayList,
//     ]);

//     // Scroll handling
//     useEffect(() => {
//       const container = containerRef?.current;
//       if (!container) return;

//       const handleScroll = () => {
//         let currentScrollTop = container?.scrollTop;

//         if (currentScrollTop > lastScrollTop) {
//           container.classList.add('scrollbar-down');
//         } else {
//           container.classList.remove('scrollbar-down');
//         }

//         lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
//       };

//       container.addEventListener('scroll', handleScroll);

//       return () => {
//         container.removeEventListener('scroll', handleScroll);
//       };
//     }, []);

//     // Navigation handlers from original component
//     const handleHome = () => {
//       playClickSound();
//       if (homeLeaderBoard) {
//         setCurrentScreenId?.(homeLeaderBoard);
//         setHomeLeaderBoard?.(null);
//       } else {
//         if (gameInfo) {
//           if (
//             gameInfo?.gameData?.gameIsShowReflectionScreen === 'true' &&
//             gameInfo?.reflectionQuestions.length > 0
//           ) {
//             setCurrentScreenId?.(3); // Navigate to Reflection screen
//           } else if (gameInfo?.gameData?.gameIsShowTakeaway === 'true') {
//             setCurrentScreenId?.(7); // Navigate to Takeaway screen
//           } else {
//             setCurrentScreenId?.(5); // Navigate to Thank you screen
//           }
//         }
//       }
//     };

//     const handleNext = () => {
//       playClickSound();
//       setFirstLoading?.(true);
//       useData?.setMotionEffect?.(true);
//       setTimeout(() => {
//         getData?.(data);
//       }, 300);
//     };

//     const previousNavigation = async () => {
//       const LastquestNo = parseInt(profile?.currentQuest);
//       setCurrentQuestNo?.(LastquestNo);
//       setCurrentScreenId?.(6);
//     };

//     const handleRightNavigation = () => {
//       playClickSound();
//       onNavigate?.('right');
//     };

//     const handleLeftNavigation = () => {
//       playClickSound();
//       if (homeLeaderBoard) {
//         handleHome();
//       } else {
//         previousNavigation();
//       }
//     };

//     const handleReplayNext = () => {
//       handleRightNavigation();
//       setIsReplayDialogOpen(false);
//     };

//     // Tab change handlers
//     const isDepartmentEmpty = departmentLeaderboardData.length === 0;
//     const handleDepartmentClick = () => {
//       if (departmentLeaderboardData.length > 0) {
//         setSelectedTab('department');
//       }
//     };

//     const handleOverallClick = () => {
//       setSelectedTab('overall');
//     };

//     // If leaderboard is disabled
//     if (formData?.gameIsShowLeaderboard !== 'true') {
//       return (
//         <div
//           className="relative h-screen w-full overflow-hidden bg-black/90 bg-cover bg-center"
//           // style={{ backgroundImage: `url('${imgBackground}')` }}
//         >
//           <div className="relative flex h-full w-full px-4   pb-4 sm:px-6 lg:px-8">
//             {/* Top Navigation Bar */}
//             <div className="absolute left-0 right-0 top-0 flex h-[5.5rem] items-center justify-between bg-cover bg-center bg-no-repeat px-4 sm:px-6 lg:px-8">
//               <div className="flex items-center gap-6"></div>
//               <div className="flex items-center gap-4">
//                 <Dialog>
//                   <DialogTrigger asChild>
//                     <div className="translate-y-1"></div>
//                   </DialogTrigger>
//                   <DialogContent
//                     className="rounded-2xl border-none px-7 py-6 shadow-lg sm:max-w-2xl"
//                     style={{
//                       background: `linear-gradient(151.477deg, rgb(0,0,0) 17.606%, rgba(${primaryColorRgb}, 0.6) 218.68%)`,
//                       border: `1px solid linear-gradient(151.477deg, rgb(0, 0, 0) 17.606%, rgba(${primaryColorRgb}, 0.4) 188.68%)`,
//                       boxShadow: '0px 0px 23.4px 0px rgba(0, 0, 0, 0.50)',
//                     }}
//                   >
//                     <h2
//                       className="py-1 text-center text-3xl font-medium"
//                       style={{
//                         color: primaryColor,
//                         textShadow: `0 0 9px rgba(${primaryColorRgb}, 0.49)`,
//                       }}
//                     >
//                       Settings
//                     </h2>

//                     {/* Decorative Line */}
//                     <div className="relative flex w-full items-center justify-center">
//                       <div className="w-full">
//                         <div className="relative h-[1px] w-full">
//                           <div
//                             className="absolute inset-0"
//                             style={{
//                               background: `linear-gradient(90deg, transparent 0%, ${primaryColor} 48%, transparent 100%)`,
//                               opacity: 0.995,
//                             }}
//                           />
//                         </div>
//                       </div>
//                     </div>

//                     <div className="mx-auto mb-2 mt-3 flex w-full max-w-md flex-col gap-8 pb-3 pt-5">
//                       <div className="flex flex-col gap-10">
//                         {/* Music Volume */}
//                         <div className="flex flex-col items-center gap-1">
//                           <label className="font-rubik mb-2 text-2xl font-normal tracking-normal text-white">
//                             Music Volume
//                           </label>
//                           <Slider
//                             defaultValue={[40]}
//                             max={100}
//                             step={1}
//                             className="w-full"
//                           />
//                         </div>
//                         {/* Voice Over Volume */}
//                         <div className="flex flex-col items-center gap-1">
//                           <label className="font-rubik mb-2 text-2xl font-normal tracking-[-0.005rem] text-white">
//                             Voice over volume
//                           </label>
//                           <Slider
//                             defaultValue={[20]}
//                             max={100}
//                             step={1}
//                             className="w-full"
//                           />
//                         </div>
//                         {/* Color Picker */}
//                         <div className="flex flex-col items-center gap-1">
//                           <label className="font-rubik mb-2 text-2xl font-normal tracking-[-0.005rem] text-white">
//                             Set Theme
//                           </label>
//                           <ColorPicker />
//                         </div>
//                       </div>

//                       {/* Okay button */}
//                       <DialogTrigger asChild>
//                         <Buttons
//                           variant="ghost"
//                           size="sm"
//                           className="rounded-4xl mx-auto h-11 w-[5.75rem] px-4 py-2 text-lg text-white transition-all duration-200 hover:scale-110 hover:text-white"
//                           style={{
//                             background: `linear-gradient(275.041deg, rgba(${primaryColorRgb}, 0.7) 7.25%, rgba(3, 51, 38, 0.8) 84.803%)`,
//                             border: `1px solid ${primaryColor}`,
//                             boxShadow: `0px 0px 15.9542px 0px rgba(3, 51, 38, 0.8)`,
//                           }}
//                         >
//                           Okay
//                         </Buttons>
//                       </DialogTrigger>
//                     </div>
//                   </DialogContent>
//                 </Dialog>
//               </div>
//             </div>

//             {/* Disabled Leaderboard Message */}
//             <div className="flex h-full flex-grow flex-col items-center justify-center pt-[7.25rem]">
//               <div
//                 className="md2x:pt-8 md2x:pb-8 relative flex h-full max-h-fit w-full max-w-7xl flex-col items-center justify-start gap-5 overflow-hidden rounded-[2.375rem] px-10 pb-6 pt-6 backdrop-blur-3xl"
//                 style={{
//                   background: `linear-gradient(21deg, rgba(${primaryColorRgb}, 0.05) -10.76%, rgba(${primaryColorRgb}, 0.1) 127.18%)`,
//                 }}
//               >
//                 <div className="relative flex h-full w-full flex-col items-center justify-center">
//                   <h1
//                     className="mb-8 text-center text-4xl font-normal tracking-normal"
//                     style={{
//                       color: primaryColor,
//                       textShadow: `rgba(${primaryColorRgb}, 0.5) 0px 0px 9px`,
//                     }}
//                   >
//                     Leaderboard Disabled
//                   </h1>
//                   <p className="mb-8 max-w-2xl text-center text-lg text-white">
//                     The "Show Leaderboard" option is currently disabled. Please
//                     enable it if you want to use this feature.
//                   </p>

//                   {/* Bottom Navigation */}
//                   <div className="mt-auto flex w-full items-center justify-between">
//                     <NavigationArrow
//                       direction="left"
//                       onClick={() => {
//                         playMenuSound(); // play the sound
//                         handleLeftNavigation(); // call the original function
//                       }}
//                       primaryColor={primaryColor}
//                     />
//                     <NavigationArrow
//                       direction="right"
//                       onClick={() => {
//                         playMenuSound(); // play the sound
//                         handleHome(); // call the original function
//                       }}
//                       primaryColor={primaryColor}
//                     />
//                   </div>

//                   {/* Inset Shadow Border */}
//                   <div
//                     className="pointer-events-none absolute inset-0 rounded-[2.375rem]"
//                     style={{
//                       boxShadow: `0px 0px 11px 0px inset rgba(${primaryColorRgb}, 0.3), 0px 0px 20px 0px rgba(${primaryColorRgb}, 0.2)`,
//                     }}
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       );
//     }

//     return (
//       <motion.div
//         initial={{ rotateY: 180, y: -100 }}
//         animate={{ rotateY: 0, y: 0 }}
//         transition={{ type: 'spring', duration: 1 }}
//         className="h-full w-full"
//       >
//         <div
//           className="relative h-screen w-full overflow-hidden bg-black/90 bg-cover bg-center"
//           // style={{ backgroundImage: `url('${imgBackground}')` }}
//         >
//           <div className="relative flex h-full w-full px-4   pb-4 sm:px-6 lg:px-8">
//             {/* Top Navigation Bar */}
//             <div className="absolute left-0 right-0 top-0 flex h-[5.5rem] items-center justify-between bg-cover bg-center bg-no-repeat px-4 sm:px-6 lg:px-8">
//               <div className="flex items-center gap-6"></div>
//               <div className="flex items-center gap-4">
//                 <Dialog>
//                   <DialogTrigger asChild>
//                     <div className="translate-y-1"></div>
//                   </DialogTrigger>
//                   <DialogContent
//                     className="rounded-2xl border-none px-7 py-6 shadow-lg sm:max-w-2xl"
//                     style={{
//                       background: `linear-gradient(151.477deg, rgb(0,0,0) 17.606%, rgba(${primaryColorRgb}, 0.6) 218.68%)`,
//                       border: `1px solid linear-gradient(151.477deg, rgb(0, 0, 0) 17.606%, rgba(${primaryColorRgb}, 0.4) 188.68%)`,
//                       boxShadow: '0px 0px 23.4px 0px rgba(0, 0, 0, 0.50)',
//                     }}
//                   >
//                     <h2
//                       className="py-1 text-center text-3xl font-medium"
//                       style={{
//                         color: primaryColor,
//                         textShadow: `0 0 9px rgba(${primaryColorRgb}, 0.49)`,
//                       }}
//                     >
//                       Settings
//                     </h2>

//                     {/* Decorative Line */}
//                     <div className="relative flex w-full items-center justify-center">
//                       <div className="w-full">
//                         <div className="relative h-[1px] w-full">
//                           <div
//                             className="absolute inset-0"
//                             style={{
//                               background: `linear-gradient(90deg, transparent 0%, ${primaryColor} 48%, transparent 100%)`,
//                               opacity: 0.995,
//                             }}
//                           />
//                         </div>
//                       </div>
//                     </div>

//                     <div className="mx-auto mb-2 mt-3 flex w-full max-w-md flex-col gap-8 pb-3 pt-5">
//                       <div className="flex flex-col gap-10">
//                         {/* Music Volume */}
//                         <div className="flex flex-col items-center gap-1">
//                           <label className="font-rubik mb-2 text-2xl font-normal tracking-normal text-white">
//                             Music Volume
//                           </label>
//                           <Slider
//                             defaultValue={[40]}
//                             max={100}
//                             step={1}
//                             className="w-full"
//                           />
//                         </div>
//                         {/* Voice Over Volume */}
//                         <div className="flex flex-col items-center gap-1">
//                           <label className="font-rubik mb-2 text-2xl font-normal tracking-[-0.005rem] text-white">
//                             Voice over volume
//                           </label>
//                           <Slider
//                             defaultValue={[20]}
//                             max={100}
//                             step={1}
//                             className="w-full"
//                           />
//                         </div>
//                         {/* Color Picker */}
//                         <div className="flex flex-col items-center gap-1">
//                           <label className="font-rubik mb-2 text-2xl font-normal tracking-[-0.005rem] text-white">
//                             Set Theme
//                           </label>
//                           <ColorPicker />
//                         </div>
//                       </div>

//                       {/* Okay button */}
//                       <DialogTrigger asChild>
//                         <Buttons
//                           variant="ghost"
//                           size="sm"
//                           className="rounded-4xl mx-auto h-11 w-[5.75rem] px-4 py-2 text-lg text-white transition-all duration-200 hover:scale-110 hover:text-white"
//                           style={{
//                             background: `linear-gradient(275.041deg, rgba(${primaryColorRgb}, 0.7) 7.25%, rgba(3, 51, 38, 0.8) 84.803%)`,
//                             border: `1px solid ${primaryColor}`,
//                             boxShadow: `0px 0px 15.9542px 0px rgba(3, 51, 38, 0.8)`,
//                           }}
//                         >
//                           Okay
//                         </Buttons>
//                       </DialogTrigger>
//                     </div>
//                   </DialogContent>
//                 </Dialog>
//               </div>
//             </div>

//             {/* Leadership Content */}
//             <div className="flex h-full flex-grow flex-col items-center justify-center pt-[7.25rem]">
//               <div
//                 className="md2x:pt-8 md2x:pb-8 relative bottom-[40px] flex h-full max-h-fit w-full max-w-7xl flex-col items-center justify-start gap-5 overflow-hidden rounded-[2.375rem] px-10 pb-6 pt-6 backdrop-blur-3xl"
//                 style={{
//                   background: `linear-gradient(21deg, rgba(${primaryColorRgb}, 0.05) -10.76%, rgba(${primaryColorRgb}, 0.1) 127.18%)`,
//                 }}
//               >
//                 {/* Leaderboard Title */}
//                 <div className="relative">
//                   <h1
//                     className="text-center text-4xl font-normal tracking-normal"
//                     style={{
//                       color: primaryColor,
//                       textShadow: `rgba(${primaryColorRgb}, 0.5) 0px 0px 9px`,
//                     }}
//                   >
//                     Leaderboard
//                   </h1>
//                 </div>

//                 {/* Decorative Line */}
//                 <div className="relative flex w-full items-center justify-center">
//                   <div className="w-full">
//                     <div className="relative h-[1px] w-full">
//                       <div
//                         className="absolute inset-0"
//                         style={{
//                           background: `linear-gradient(90deg, transparent 0%, ${primaryColor} 48%, transparent 100%)`,
//                           opacity: 0.995,
//                         }}
//                       />
//                     </div>
//                   </div>
//                 </div>

//                 {/* Tabs using ShadCN */}
//                 <div className="max-md2x:overflow-y-auto w-full">
//                   <Tabs
//                     value={selectedTab}
//                     onValueChange={(value) =>
//                       setSelectedTab(value as 'department' | 'overall')
//                     }
//                     className="w-full"
//                   >
//                     <TabsList
//                       className="max-md2x:position-sticky max-md2x:top-0 max-md2x:z-10 grid w-full grid-cols-2 gap-3 bg-transparent p-0"
//                       style={{
//                         background: 'transparent',
//                       }}
//                     >
//                       <TabsTrigger
//                         value="overall"
//                         className="font-rubik rounded-sm border px-3 py-3.5 text-xl font-medium tracking-[-0.048px] transition-all duration-200 hover:scale-[1.01] data-[state=active]:bg-transparent data-[state=active]:shadow-none"
//                         style={{
//                           borderWidth: '0.548px',
//                           borderColor:
//                             selectedTab === 'overall'
//                               ? `rgba(${primaryColorRgb}, 0.5)`
//                               : '#000000',
//                           color:
//                             selectedTab === 'overall'
//                               ? primaryColor
//                               : 'rgba(255,255,255,0.5)',
//                           boxShadow: '0px 0px 12.485px 0px rgba(0,0,0,0.5)',
//                           opacity: selectedTab === 'overall' ? 1 : 0.8,
//                           background: `linear-gradient(21deg, rgba(${primaryColorRgb}, 0.02) -10.76%, rgba(${primaryColorRgb}, 0.1) 127.18%)`,
//                         }}
//                       >
//                         Overall
//                       </TabsTrigger>
//                       <TabsTrigger
//                         value="department"
//                         className="font-rubik rounded-sm border px-3 py-3.5 text-xl font-medium tracking-[-0.048px] transition-all duration-200 hover:scale-[1.01] data-[state=active]:bg-transparent data-[state=active]:shadow-none"
//                         style={{
//                           borderWidth: '0.548px',
//                           borderColor:
//                             selectedTab === 'department'
//                               ? `rgba(${primaryColorRgb}, 0.5)`
//                               : '#000000',
//                           color:
//                             selectedTab === 'department'
//                               ? primaryColor
//                               : 'rgba(255,255,255,0.5)',
//                           boxShadow: '0px 0px 12.485px 0px rgba(0,0,0,0.5)',
//                           opacity:
//                             selectedTab === 'department' && !isDepartmentEmpty
//                               ? 1
//                               : 0.5,
//                           background: `linear-gradient(21deg, rgba(${primaryColorRgb}, 0.02) -10.76%, rgba(${primaryColorRgb}, 0.1) 127.18%)`,
//                           cursor: isDepartmentEmpty ? 'not-allowed' : 'pointer',
//                         }}
//                         onClick={handleDepartmentClick}
//                         disabled={isDepartmentEmpty}
//                       >
//                         Department
//                       </TabsTrigger>
//                     </TabsList>

//                     <TabsContent value="overall" className="mt-4">
//                       {/* Leaderboard Table using shadcn */}
//                       <div
//                         className="relative w-full shrink-0 rounded-[0.564rem]"
//                         ref={containerRef}
//                       >
//                         <div
//                           className="box-border flex w-full flex-col content-stretch items-start justify-start overflow-clip rounded-md p-2"
//                           style={{
//                             backgroundImage:
//                               'linear-gradient(90deg, rgba(0, 0, 0, 0.63) 0%, rgba(0, 0, 0, 0.63) 100%)',
//                             backgroundSize: 'auto, cover',
//                             backgroundPosition: '0% 0%, 50% 50%',
//                           }}
//                         >
//                           <Table className="w-full table-fixed">
//                             <TableHeader>
//                               <TableRow className="border-b-0 hover:bg-transparent">
//                                 <TableHead className="font-poppins h-[1.879rem] w-[10.38rem] border-r border-[#3d3d3d] bg-[rgba(0,0,0,0.5)] text-center text-sm font-semibold text-[#7f7d83]">
//                                   Player Name
//                                 </TableHead>
//                                 <TableHead
//                                   className="font-poppins h-[1.879rem] border-r border-[#3d3d3d] bg-[rgba(0,0,0,0.5)] px-4 text-center text-sm font-semibold text-[#7f7d83]"
//                                   colSpan={2}
//                                 >
//                                   Daily
//                                 </TableHead>
//                                 <TableHead
//                                   className="font-poppins h-[1.879rem] bg-[rgba(0,0,0,0.5)] px-4 text-center text-sm font-semibold text-[#7f7d83]"
//                                   colSpan={2}
//                                 >
//                                   All Time
//                                 </TableHead>
//                               </TableRow>
//                               <TableRow className="border-b-0 hover:bg-transparent">
//                                 <TableHead className="h-[1.879rem] w-[10.38rem] border-r border-[#3d3d3d] bg-[rgba(0,0,0,0.5)]"></TableHead>
//                                 <TableHead className="font-poppins h-[1.879rem] w-24 border-r border-[#3d3d3d] bg-[rgba(0,0,0,0.5)] text-center text-sm font-semibold text-[#7f7d83]">
//                                   Position
//                                 </TableHead>
//                                 <TableHead className="font-poppins h-[1.879rem] w-24 border-r border-[#3d3d3d] bg-[rgba(0,0,0,0.5)] text-center text-sm font-semibold text-[#7f7d83]">
//                                   Score
//                                 </TableHead>
//                                 <TableHead className="font-poppins h-[1.879rem] w-24 border-r border-[#3d3d3d] bg-[rgba(0,0,0,0.5)] text-center text-sm font-semibold text-[#7f7d83]">
//                                   Position
//                                 </TableHead>
//                                 <TableHead className="font-poppins h-[1.879rem] w-24 bg-[rgba(0,0,0,0.5)] text-center text-sm font-semibold text-[#7f7d83]">
//                                   Score
//                                 </TableHead>
//                               </TableRow>
//                             </TableHeader>
//                           </Table>
//                           <div className="max-h-[200px] w-full overflow-y-auto overflow-x-hidden">
//                             <Table className="w-full table-fixed">
//                               <TableBody>
//                                 {leaderboardToRender.map((player, index) => {
//                                   const isUser =
//                                     player.name ===
//                                     (learnerPlayList?.LearnerProfile
//                                       ?.nickName ??
//                                       learnerPlayList?.LearnerProfile?.name);
//                                   return (
//                                     <TableRow
//                                       key={index}
//                                       className="h-[3.188rem] border-b"
//                                       style={{
//                                         borderBottomColor: isUser
//                                           ? primaryColor
//                                           : '#3d3d3d',
//                                         borderBottomWidth: '0.751px',
//                                         backgroundColor: isUser
//                                           ? `rgba(${primaryColorRgb},0.15)`
//                                           : '',
//                                       }}
//                                     >
//                                       <TableCell
//                                         className="font-rubik w-[10.38rem] border-r border-[#3d3d3d] pl-[1.691rem] text-base font-semibold tracking-[-0.0376px]"
//                                         style={{
//                                           color: isUser
//                                             ? primaryColor
//                                             : '#ffffff',
//                                           borderRightColor: '#3d3d3d',
//                                         }}
//                                       >
//                                         {player.name || 'Guest'}
//                                       </TableCell>
//                                       <TableCell
//                                         className="font-rubik w-24 border-r border-[#3d3d3d] text-center text-base font-semibold tracking-[-0.0376px]"
//                                         style={{
//                                           color: isUser
//                                             ? primaryColor
//                                             : '#ffffff',
//                                           borderRightColor: '#3d3d3d',
//                                         }}
//                                       >
//                                         {player.dailyPosition ?? index + 1}
//                                       </TableCell>
//                                       <TableCell
//                                         className="font-rubik w-24 border-r border-[#3d3d3d] text-center text-base font-semibold tracking-[-0.0376px]"
//                                         style={{
//                                           color: isUser
//                                             ? primaryColor
//                                             : '#ffffff',
//                                           borderRightColor: '#3d3d3d',
//                                         }}
//                                       >
//                                         {player.score ?? 0}
//                                       </TableCell>
//                                       <TableCell
//                                         className="font-rubik w-24 border-r border-[#3d3d3d] text-center text-base font-semibold tracking-[-0.0376px]"
//                                         style={{
//                                           color: isUser
//                                             ? primaryColor
//                                             : '#ffffff',
//                                           borderRightColor: '#3d3d3d',
//                                         }}
//                                       >
//                                         {player.alltimePosition ?? index + 1}
//                                       </TableCell>
//                                       <TableCell
//                                         className="font-rubik w-24 text-center text-base font-semibold tracking-[-0.0376px]"
//                                         style={{
//                                           color: isUser
//                                             ? primaryColor
//                                             : '#ffffff',
//                                         }}
//                                       >
//                                         {player.allTimeScore ?? 0}
//                                       </TableCell>
//                                     </TableRow>
//                                   );
//                                 })}
//                               </TableBody>
//                             </Table>
//                           </div>
//                         </div>
//                       </div>
//                     </TabsContent>

//                     <TabsContent value="department" className="mt-4">
//                       {/* Department tab - same structure as overall */}
//                       <div
//                         className="relative w-full shrink-0 rounded-[0.564rem]"
//                         ref={containerRef}
//                       >
//                         <div
//                           className="box-border flex w-full flex-col content-stretch items-start justify-start overflow-clip rounded-md p-2"
//                           style={{
//                             backgroundImage:
//                               'linear-gradient(90deg, rgba(0, 0, 0, 0.63) 0%, rgba(0, 0, 0, 0.63) 100%)',
//                             backgroundSize: 'auto, cover',
//                             backgroundPosition: '0% 0%, 50% 50%',
//                           }}
//                         >
//                           <Table className="w-full table-fixed">
//                             <TableHeader>
//                               <TableRow className="border-b-0 hover:bg-transparent">
//                                 <TableHead className="font-poppins h-[1.879rem] w-[10.38rem] border-r border-[#3d3d3d] bg-[rgba(0,0,0,0.5)] text-center text-sm font-semibold text-[#7f7d83]">
//                                   Player Name
//                                 </TableHead>
//                                 <TableHead
//                                   className="font-poppins h-[1.879rem] border-r border-[#3d3d3d] bg-[rgba(0,0,0,0.5)] px-4 text-center text-sm font-semibold text-[#7f7d83]"
//                                   colSpan={2}
//                                 >
//                                   Daily
//                                 </TableHead>
//                                 <TableHead
//                                   className="font-poppins h-[1.879rem] bg-[rgba(0,0,0,0.5)] px-4 text-center text-sm font-semibold text-[#7f7d83]"
//                                   colSpan={2}
//                                 >
//                                   All Time
//                                 </TableHead>
//                               </TableRow>
//                               <TableRow className="border-b-0 hover:bg-transparent">
//                                 <TableHead className="h-[1.879rem] w-[10.38rem] border-r border-[#3d3d3d] bg-[rgba(0,0,0,0.5)]"></TableHead>
//                                 <TableHead className="font-poppins h-[1.879rem] w-24 border-r border-[#3d3d3d] bg-[rgba(0,0,0,0.5)] text-center text-sm font-semibold text-[#7f7d83]">
//                                   Position
//                                 </TableHead>
//                                 <TableHead className="font-poppins h-[1.879rem] w-24 border-r border-[#3d3d3d] bg-[rgba(0,0,0,0.5)] text-center text-sm font-semibold text-[#7f7d83]">
//                                   Score
//                                 </TableHead>
//                                 <TableHead className="font-poppins h-[1.879rem] w-24 border-r border-[#3d3d3d] bg-[rgba(0,0,0,0.5)] text-center text-sm font-semibold text-[#7f7d83]">
//                                   Position
//                                 </TableHead>
//                                 <TableHead className="font-poppins h-[1.879rem] w-24 bg-[rgba(0,0,0,0.5)] text-center text-sm font-semibold text-[#7f7d83]">
//                                   Score
//                                 </TableHead>
//                               </TableRow>
//                             </TableHeader>
//                           </Table>
//                           <div className="max-h-[200px] w-full overflow-y-auto overflow-x-hidden">
//                             <Table className="w-full table-fixed">
//                               <TableBody>
//                                 {leaderboardToRender.map((player, index) => {
//                                   const isUser =
//                                     player.name ===
//                                     (learnerPlayList?.LearnerProfile
//                                       ?.nickName ??
//                                       learnerPlayList?.LearnerProfile?.name);
//                                   return (
//                                     <TableRow
//                                       key={index}
//                                       className="h-[3.188rem] border-b"
//                                       style={{
//                                         borderBottomColor: isUser
//                                           ? primaryColor
//                                           : '#3d3d3d',
//                                         borderBottomWidth: '0.751px',
//                                         backgroundColor: isUser
//                                           ? `rgba(${primaryColorRgb},0.15)`
//                                           : '',
//                                       }}
//                                     >
//                                       <TableCell
//                                         className="font-rubik w-[10.38rem] border-r border-[#3d3d3d] pl-[1.691rem] text-base font-semibold tracking-[-0.0376px]"
//                                         style={{
//                                           color: isUser
//                                             ? primaryColor
//                                             : '#ffffff',
//                                           borderRightColor: '#3d3d3d',
//                                         }}
//                                       >
//                                         {player.name || 'Guest'}
//                                       </TableCell>
//                                       <TableCell
//                                         className="font-rubik w-24 border-r border-[#3d3d3d] text-center text-base font-semibold tracking-[-0.0376px]"
//                                         style={{
//                                           color: isUser
//                                             ? primaryColor
//                                             : '#ffffff',
//                                           borderRightColor: '#3d3d3d',
//                                         }}
//                                       >
//                                         {player.dailyPosition ?? index + 1}
//                                       </TableCell>
//                                       <TableCell
//                                         className="font-rubik w-24 border-r border-[#3d3d3d] text-center text-base font-semibold tracking-[-0.0376px]"
//                                         style={{
//                                           color: isUser
//                                             ? primaryColor
//                                             : '#ffffff',
//                                           borderRightColor: '#3d3d3d',
//                                         }}
//                                       >
//                                         {player.score ?? 0}
//                                       </TableCell>
//                                       <TableCell
//                                         className="font-rubik w-24 border-r border-[#3d3d3d] text-center text-base font-semibold tracking-[-0.0376px]"
//                                         style={{
//                                           color: isUser
//                                             ? primaryColor
//                                             : '#ffffff',
//                                           borderRightColor: '#3d3d3d',
//                                         }}
//                                       >
//                                         {player.alltimePosition ?? index + 1}
//                                       </TableCell>
//                                       <TableCell
//                                         className="font-rubik w-24 text-center text-base font-semibold tracking-[-0.0376px]"
//                                         style={{
//                                           color: isUser
//                                             ? primaryColor
//                                             : '#ffffff',
//                                         }}
//                                       >
//                                         {player.allTimeScore ?? 0}
//                                       </TableCell>
//                                     </TableRow>
//                                   );
//                                 })}
//                               </TableBody>
//                             </Table>
//                           </div>
//                         </div>
//                       </div>
//                     </TabsContent>
//                   </Tabs>
//                 </div>

//                 {/* Bottom Navigation */}
//                 <div className="flex w-full items-center justify-between">
//                   <NavigationArrow
//                     direction="left"
//                     onClick={handleLeftNavigation}
//                     primaryColor={primaryColor}
//                   />
//                   <NavigationArrow
//                     direction="right"
//                     onClick={() => handleNext()}
//                     primaryColor={primaryColor}
//                   />
//                 </div>

//                 {/* Inset Shadow Border */}
//                 <div
//                   className="pointer-events-none absolute inset-0 rounded-[2.375rem]"
//                   style={{
//                     boxShadow: `0px 0px 11px 0px inset rgba(${primaryColorRgb}, 0.3), 0px 0px 20px 0px rgba(${primaryColorRgb}, 0.2)`,
//                   }}
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </motion.div>
//     );
//   },
// );

// export default LeaderBoardFutureTheme;



//diwaker code

'use client';
import React from 'react';
import { useState, useContext, useEffect, useRef, useMemo } from 'react';
import { Buttons } from '../../../../components/ui/button';
import { Badge } from '../../../../components/ui/badge';
import {
  Tabs,
  TabsList,
  TabsTrigger,
  TabsContent,
} from '../../../../components/ui/tabs';
import BtnClickSound from '../../../../assets/adiuo/simple-btn-click.mp3';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../../../../components/ui/table';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import svgPaths from '../../../../imports/svg-knollny4nu';
import {
  CustomCoinIcon,
  CustomHomeIcon,
  CustomMapIcon,
  CustomRankingIcon,
  CustomSettingsIcon,
} from '../../../../components/ui/CustomIcons';
// import imgBackground from "/images/background.png";
import { useColor } from '../../../../components/ui/ColorContext';
import ColorPicker from '../../../../components/ui/ColorPicker';
import { Slider } from '../../../../components/ui/slider';
import {
  Dialog,
  DialogContent,
  DialogTrigger,
} from '../../../../components/ui/dialog';
// import { ReplayDialog } from "./ReplayDialog";
import { motion } from 'framer-motion';
import { getLeaderboardData } from 'utils/gameApplication/gamePlayService';
import { useParams } from 'react-router-dom';

// Helper function to convert hex to RGB
const hexToRgb = (hex: string): string => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (!result) return '0, 255, 187'; // fallback to default green
  const r = Number.parseInt(result[1], 16);
  const g = Number.parseInt(result[2], 16);
  const b = Number.parseInt(result[3], 16);
  return `${r}, ${g}, ${b}`;
};

// Moved NavigationArrow outside to prevent recreation
const NavigationArrow: React.FC<{
  direction: 'left' | 'right';
  onClick: () => void;
  primaryColor: string;
}> = React.memo(({ direction, onClick, primaryColor }) => {
  const primaryColorRgb = hexToRgb(primaryColor);

  return (
    <Buttons
      variant="ghost"
      size="sm"
      onClick={onClick}
      className="h-10 w-[3.75rem] rounded-3xl px-4 py-2 transition-all duration-200 hover:scale-110"
      style={{
        background: `linear-gradient(${
          direction === 'left' ? '275.041deg' : '90deg'
        },
              rgba(${primaryColorRgb}, 0.6) 7.25%, rgba(${primaryColorRgb}, 0.15) 84.803%)`,
        border: `1px solid ${primaryColor}`,
        boxShadow: `0px 0px 15.9542px 0px rgba(${primaryColorRgb}, 0.3)`,
      }}
    >
      {direction === 'left' ? (
        <ChevronLeft className="!h-4 !w-4 text-white" />
      ) : (
        <ChevronRight className="!h-4 !w-4 text-white" />
      )}
    </Buttons>
  );
});

const LeaderBoardFutureTheme: React.FC<{
  onNavigate?: (direction: 'left' | 'right') => void;
  formData?: any;
  playMenuSound: () => void;
  imageSrc?: any;
  getData?: any;
  data?: any;
  homeLeaderBoard?: any;
  setHomeLeaderBoard?: any;
  setCurrentScreenId?: any;
  currentScreenId?: any;
  gameInfo?: any;
  preloadedAssets: any;
  setPlayerTodayScore: any;
  playerTodayScore: any;
  setCurrentQuestNo: any;
  setFirstLoading: any;
  learnerPlayList: any;
  profile?: any;
  setProfile?: any;
  useData?: any;
}> = React.memo(
  ({
    onNavigate,
    formData,
    imageSrc,
    getData,
    data,
    setCurrentScreenId,
    currentScreenId,
    homeLeaderBoard,
    setHomeLeaderBoard,
    gameInfo,
    preloadedAssets,
    setPlayerTodayScore,
    playerTodayScore,
    setCurrentQuestNo,
    setFirstLoading,
    learnerPlayList,
    profile,
    playMenuSound,
    setProfile,
    useData,
  }) => {
    const playClickSound = () => {
      try {
        const audio = new Audio(BtnClickSound as string);
        audio.volume = 1;
        audio.play().catch(() => {});

        setTimeout(() => {
          audio.pause();
          audio.currentTime = 0;
        }, 1000);
      } catch (e) {
        // ignore audio errors
      }
    };

    const { primaryColor } = useColor();
    const primaryColorRgb = useMemo(
      () => hexToRgb(primaryColor),
      [primaryColor],
    );

    const [selectedTab, setSelectedTab] = useState<'department' | 'overall'>(
      'overall',
    );
    const [isReplayDialogOpen, setIsReplayDialogOpen] = useState(false);
    const { learner_game_play_id } = useParams();

    // State from original component
    const [shuffledUsers, setShuffledUsers] = useState<any[]>([]);
    const [allTimeClicked, setAllTimeClicked] = useState(false);
    const [newSortedUserss, setNewSortedUserss] = useState<any[]>([]);
    const [sortedUsers, setSortedUsers] = useState<any[]>([]);
    const [sortAse, setSortAse] = useState({ daily: true, allTime: true });
    const [departmentLeaderboardData, setDepartmentLeaderboardData] = useState<
      any[]
    >([]);
    const [companyLeaderboardData, setCompanyLeaderboardData] = useState<any[]>(
      [],
    );

    const containerRef = useRef<any>(null);
    let lastScrollTop = 0;

    const hasFetchedRef = useRef(false);
    useEffect(() => {
      if (currentScreenId !== 4) return;

      if (!learner_game_play_id || hasFetchedRef.current) return;

      const getAllLearnerScores = async () => {
        const getLeaderboardDatas = await getLeaderboardData(
          learner_game_play_id,
        );

        if (getLeaderboardDatas?.departmentLeaderboardData) {
          setDepartmentLeaderboardData(
            getLeaderboardDatas.departmentLeaderboardData,
          );
        }

        if (getLeaderboardDatas?.companyLeaderboardData) {
          setCompanyLeaderboardData(getLeaderboardDatas.companyLeaderboardData);
        }
      };

      getAllLearnerScores();

      hasFetchedRef.current = true;
    }, [learner_game_play_id]);

    // Calculate player today score
    useEffect(() => {
      const currentDate = new Date();
      const day = String(currentDate.getDate()).padStart(2, '0');
      const month = String(currentDate.getMonth() + 1).padStart(2, '0');
      const year = currentDate.getFullYear();
      const formattedDate = `${day}-${month}-${year}`;

      const scores = profile?.score;
      const sums: any = {};
      scores?.forEach((score: any) => {
        const quest = score.quest;
        if (!sums[quest]) {
          sums[quest] = 0;
        }
        if (score.scoreEarnedDate === formattedDate) {
          sums[quest] += score.score;
        }
      });

      let getFinalscores = {};
      Object.entries(sums).forEach(([quest, score]) => {
        const IntQuest = parseInt(quest);
        const newQuest = { ...getFinalscores, [IntQuest]: score };
        getFinalscores = { ...newQuest };
      });

      const Replayscores =
        profile?.replayScore?.length > 0 ? profile?.replayScore : null;
      const Replaysums: { [key: number]: number } = {};
      Replayscores?.forEach((score: any) => {
        const quest = score.quest;
        if (!Replaysums[quest]) {
          Replaysums[quest] = 0;
        }
        if (score.scoreEarnedDate === formattedDate) {
          Replaysums[quest] += score.score;
        }
      });

      let getReplayFinalscores: { [key: number]: number } = {};
      Object.entries(Replaysums).forEach(([quest, score]) => {
        const IntQuest = parseInt(quest);
        getReplayFinalscores = { ...getReplayFinalscores, [IntQuest]: score };
      });

      const TodayTotalScore = Object.entries(getFinalscores).reduce(
        (tot: number, acc: any) => {
          let questNo = acc[0];
          let questHasReplay = Object.keys(getReplayFinalscores).some(
            (quest) => quest === questNo,
          );
          if (questHasReplay) {
            getReplayFinalscores[questNo] > acc[1]
              ? (tot += getReplayFinalscores[questNo])
              : (tot += acc[1]);
          } else {
            tot += acc[1];
          }
          return tot;
        },
        0,
      );
      setPlayerTodayScore(TodayTotalScore);
    }, [playerTodayScore, profile, setPlayerTodayScore]);

    // Process leaderboard data
    const leaderboardToRender = useMemo(() => {
      const currentBoard =
        selectedTab === 'department'
          ? departmentLeaderboardData
          : companyLeaderboardData;
      const data = Array.isArray(currentBoard) ? currentBoard.slice() : [];

      // Map scores to positions (daily)
      const dailySorted = data
        .slice()
        .sort((a, b) => (b.score ?? 0) - (a.score ?? 0));
      const dailyPos = new Map<number | string, number>();
      dailySorted.forEach((item, idx) => {
        const key = item.learnerId ?? item.name ?? idx;
        dailyPos.set(key, idx + 1);
      });

      // Map allTimeScore to positions (all time)
      const alltimeSorted = data
        .slice()
        .sort((a, b) => (b.allTimeScore ?? 0) - (a.allTimeScore ?? 0));
      const alltimePos = new Map<number | string, number>();
      alltimeSorted.forEach((item, idx) => {
        const key = item.learnerId ?? item.name ?? idx;
        alltimePos.set(key, idx + 1);
      });

      // Attach positions
      const augmented = data.map((item, idx) => {
        const key = item.learnerId ?? item.name ?? idx;
        return {
          ...item,
          dailyPosition: dailyPos.get(key) ?? idx + 1,
          alltimePosition: alltimePos.get(key) ?? idx + 1,
        };
      });

      // Order by daily score for display (highest first)
      const ordered = augmented
        .slice()
        .sort((a, b) => (b.score ?? 0) - (a.score ?? 0));

      // If you want the currently-playing user to appear visually at the top,
      // find them and move their row to index 0 (positions remain unchanged).
      const playerName =
        learnerPlayList?.LearnerProfile?.nickName ??
        learnerPlayList?.LearnerProfile?.name;
      if (playerName) {
        const playerIndex = ordered.findIndex((it) => it.name === playerName);
        if (playerIndex > -1) {
          const [playerRow] = ordered.splice(playerIndex, 1);
          ordered.unshift(playerRow);
        }
      }

      return ordered;
    }, [
      selectedTab,
      departmentLeaderboardData,
      companyLeaderboardData,
      learnerPlayList,
    ]);

    // Scroll handling
    useEffect(() => {
      const container = containerRef?.current;
      if (!container) return;

      const handleScroll = () => {
        let currentScrollTop = container?.scrollTop;

        if (currentScrollTop > lastScrollTop) {
          container.classList.add('scrollbar-down');
        } else {
          container.classList.remove('scrollbar-down');
        }

        lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
      };

      container.addEventListener('scroll', handleScroll);

      return () => {
        container.removeEventListener('scroll', handleScroll);
      };
    }, []);

    // Navigation handlers from original component
    const handleHome = () => {
      playClickSound();
      if (homeLeaderBoard) {
        setCurrentScreenId?.(homeLeaderBoard);
        setHomeLeaderBoard?.(null);
      } else {
        if (gameInfo) {
          if (
            gameInfo?.gameData?.gameIsShowReflectionScreen === 'true' &&
            gameInfo?.reflectionQuestions.length > 0
          ) {
            setCurrentScreenId?.(3); // Navigate to Reflection screen
          } else if (gameInfo?.gameData?.gameIsShowTakeaway === 'true') {
            setCurrentScreenId?.(7); // Navigate to Takeaway screen
          } else {
            setCurrentScreenId?.(5); // Navigate to Thank you screen
          }
        }
      }
    };

    const handleNext = () => {
      playClickSound();
      setFirstLoading?.(true);
      useData?.setMotionEffect?.(true);
      setTimeout(() => {
        getData?.(data);
      }, 300);
    };

    const previousNavigation = async () => {
      const LastquestNo = parseInt(profile?.currentQuest);
      setCurrentQuestNo?.(LastquestNo);
      setCurrentScreenId?.(6);
    };

    const handleRightNavigation = () => {
      playClickSound();
      onNavigate?.('right');
    };

    const handleLeftNavigation = () => {
      playClickSound();
      if (homeLeaderBoard) {
        handleHome();
      } else {
        previousNavigation();
      }
    };

    const handleReplayNext = () => {
      handleRightNavigation();
      setIsReplayDialogOpen(false);
    };

    // Tab change handlers
    const isDepartmentEmpty = departmentLeaderboardData.length === 0;
    const handleDepartmentClick = () => {
      if (departmentLeaderboardData.length > 0) {
        setSelectedTab('department');
      }
    };

    const handleOverallClick = () => {
      setSelectedTab('overall');
    };

    // If leaderboard is disabled
    if (formData?.gameIsShowLeaderboard !== 'true') {
      return (
        <div
          className="relative h-screen w-full overflow-hidden bg-black/90 bg-cover bg-center"
          // style={{ backgroundImage: `url('${imgBackground}')` }}
        >
          <div className="relative flex h-full w-full px-4   pb-4 sm:px-6 lg:px-8">
            {/* Top Navigation Bar */}
            <div className="absolute left-0 right-0 top-0 flex h-[5.5rem] items-center justify-between bg-cover bg-center bg-no-repeat px-4 sm:px-6 lg:px-8">
              <div className="flex items-center gap-6"></div>
              <div className="flex items-center gap-4">
                <Dialog>
                  <DialogTrigger asChild>
                    <div className="translate-y-1"></div>
                  </DialogTrigger>
                  <DialogContent
                    className="rounded-2xl border-none px-7 py-6 shadow-lg sm:max-w-2xl"
                    style={{
                      background: `linear-gradient(151.477deg, rgb(0,0,0) 17.606%, rgba(${primaryColorRgb}, 0.6) 218.68%)`,
                      border: `1px solid linear-gradient(151.477deg, rgb(0, 0, 0) 17.606%, rgba(${primaryColorRgb}, 0.4) 188.68%)`,
                      boxShadow: '0px 0px 23.4px 0px rgba(0, 0, 0, 0.50)',
                    }}
                  >
                    <h2
                      className="py-1 text-center text-3xl font-medium"
                      style={{
                        color: primaryColor,
                        textShadow: `0 0 9px rgba(${primaryColorRgb}, 0.49)`,
                      }}
                    >
                      Settings
                    </h2>

                    {/* Decorative Line */}
                    <div className="relative flex w-full items-center justify-center">
                      <div className="w-full">
                        <div className="relative h-[1px] w-full">
                          <div
                            className="absolute inset-0"
                            style={{
                              background: `linear-gradient(90deg, transparent 0%, ${primaryColor} 48%, transparent 100%)`,
                              opacity: 0.995,
                            }}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="mx-auto mb-2 mt-3 flex w-full max-w-md flex-col gap-8 pb-3 pt-5">
                      <div className="flex flex-col gap-10">
                        {/* Music Volume */}
                        <div className="flex flex-col items-center gap-1">
                          <label className="font-rubik mb-2 text-2xl font-normal tracking-normal text-white">
                            Music Volume
                          </label>
                          <Slider
                            defaultValue={[40]}
                            max={100}
                            step={1}
                            className="w-full"
                          />
                        </div>
                        {/* Voice Over Volume */}
                        <div className="flex flex-col items-center gap-1">
                          <label className="font-rubik mb-2 text-2xl font-normal tracking-[-0.005rem] text-white">
                            Voice over volume
                          </label>
                          <Slider
                            defaultValue={[20]}
                            max={100}
                            step={1}
                            className="w-full"
                          />
                        </div>
                        {/* Color Picker */}
                        <div className="flex flex-col items-center gap-1">
                          <label className="font-rubik mb-2 text-2xl font-normal tracking-[-0.005rem] text-white">
                            Set Theme
                          </label>
                          <ColorPicker />
                        </div>
                      </div>

                      {/* Okay button */}
                      <DialogTrigger asChild>
                        <Buttons
                          variant="ghost"
                          size="sm"
                          className="rounded-4xl mx-auto h-11 w-[5.75rem] px-4 py-2 text-lg text-white transition-all duration-200 hover:scale-110 hover:text-white"
                          style={{
                            background: `linear-gradient(275.041deg, rgba(${primaryColorRgb}, 0.7) 7.25%, rgba(3, 51, 38, 0.8) 84.803%)`,
                            border: `1px solid ${primaryColor}`,
                            boxShadow: `0px 0px 15.9542px 0px rgba(3, 51, 38, 0.8)`,
                          }}
                        >
                          Okay
                        </Buttons>
                      </DialogTrigger>
                    </div>
                  </DialogContent>
                </Dialog>
              </div>
            </div>

            {/* Disabled Leaderboard Message */}
            <div className="flex flex-grow flex-col
items-center
justify-start
pt-20 sm:pt-[7rem]
">
              <div
                className="relative
w-full
max-w-7xl
h-auto
flex
flex-col
overflow-hidden
rounded-[2.375rem]
px-4 sm:px-6 lg:px-10
py-4 sm:py-6"
                style={{
                  background: `linear-gradient(21deg, rgba(${primaryColorRgb}, 0.05) -10.76%, rgba(${primaryColorRgb}, 0.1) 127.18%)`,
                }}
              >
                <div className="relative flex max-h-fit w-full flex-col items-center justify-start">
                  <h1
                    className="mb-8 text-center text-2xl sm:text-3xl lg:text-4xl font-normal tracking-normal"
                    style={{
                      color: primaryColor,
                      textShadow: `rgba(${primaryColorRgb}, 0.5) 0px 0px 9px`,
                    }}
                  >
                    Leaderboard Disabled
                  </h1>
                  <p className="mb-8 max-w-2xl text-center text-lg text-white">
                    The "Show Leaderboard" option is currently disabled. Please
                    enable it if you want to use this feature.
                  </p>

                  {/* Bottom Navigation */}
                  <div className="mt-auto mt-auto shrink-0 flex w-full items-center justify-between">
                    <NavigationArrow
                      direction="left"
                      onClick={() => {
                        playMenuSound(); // play the sound
                        handleLeftNavigation(); // call the original function
                      }}
                      primaryColor={primaryColor}
                    />
                    <NavigationArrow
                      direction="right"
                      onClick={() => {
                        playMenuSound(); // play the sound
                        handleHome(); // call the original function
                      }}
                      primaryColor={primaryColor}
                    />
                  </div>

                  {/* Inset Shadow Border */}
                  <div
                    className="pointer-events-none absolute inset-0 rounded-[2.375rem]"
                    style={{
                      boxShadow: `0px 0px 11px 0px inset rgba(${primaryColorRgb}, 0.3), 0px 0px 20px 0px rgba(${primaryColorRgb}, 0.2)`,
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <motion.div
        initial={{ rotateY: 180, y: -100 }}
        animate={{ rotateY: 0, y: 0 }}
        transition={{ type: 'spring', duration: 1 }}
        className="max-h-fit w-full"
      >
        <div
          className="relative h-screen w-full overflow-hidden bg-black/90 bg-cover bg-center"
          // style={{ backgroundImage: `url('${imgBackground}')` }}
        >
          <div className="relative flex max-h-fit w-full px-4   pb-4 sm:px-6 lg:px-8">
            {/* Top Navigation Bar */}
            <div className="absolute left-0 right-0 top-0 flex h-[5.5rem] items-center justify-between bg-cover bg-center bg-no-repeat px-4 sm:px-6 lg:px-8">
              <div className="flex items-center gap-6"></div>
              <div className="flex items-center gap-4">
                <Dialog>
                  <DialogTrigger asChild>
                    <div className="translate-y-1"></div>
                  </DialogTrigger>
                  <DialogContent
                    className="rounded-2xl border-none px-7 py-6 shadow-lg sm:max-w-2xl"
                    style={{
                      background: `linear-gradient(151.477deg, rgb(0,0,0) 17.606%, rgba(${primaryColorRgb}, 0.6) 218.68%)`,
                      border: `1px solid linear-gradient(151.477deg, rgb(0, 0, 0) 17.606%, rgba(${primaryColorRgb}, 0.4) 188.68%)`,
                      boxShadow: '0px 0px 23.4px 0px rgba(0, 0, 0, 0.50)',
                    }}
                  >
                    <h2
                      className="py-1 text-center text-3xl font-medium"
                      style={{
                        color: primaryColor,
                        textShadow: `0 0 9px rgba(${primaryColorRgb}, 0.49)`,
                      }}
                    >
                      Settings
                    </h2>

                    {/* Decorative Line */}
                    <div className="relative flex w-full items-center justify-start">
                      <div className="w-full">
                        <div className="relative h-[1px] w-full">
                          <div
                            className="absolute inset-0"
                            style={{
                              background: `linear-gradient(90deg, transparent 0%, ${primaryColor} 48%, transparent 100%)`,
                              opacity: 0.995,
                            }}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="mx-auto mb-2 mt-3 flex w-full max-w-md flex-col gap-8 pb-3 pt-5">
                      <div className="flex flex-col gap-10">
                        {/* Music Volume */}
                        <div className="flex flex-col items-center gap-1">
                          <label className="font-rubik mb-2 text-2xl font-normal tracking-normal text-white">
                            Music Volume
                          </label>
                          <Slider
                            defaultValue={[40]}
                            max={100}
                            step={1}
                            className="w-full"
                          />
                        </div>
                        {/* Voice Over Volume */}
                        <div className="flex flex-col items-center gap-1">
                          <label className="font-rubik mb-2 text-2xl font-normal tracking-[-0.005rem] text-white">
                            Voice over volume
                          </label>
                          <Slider
                            defaultValue={[20]}
                            max={100}
                            step={1}
                            className="w-full"
                          />
                        </div>
                        {/* Color Picker */}
                        <div className="flex flex-col items-center gap-1">
                          <label className="font-rubik mb-2 text-2xl font-normal tracking-[-0.005rem] text-white">
                            Set Theme
                          </label>
                          <ColorPicker />
                        </div>
                      </div>

                      {/* Okay button */}
                      <DialogTrigger asChild>
                        <Buttons
                          variant="ghost"
                          size="sm"
                          className="rounded-4xl mx-auto h-11 w-[5.75rem] px-4 py-2 text-lg text-white transition-all duration-200 hover:scale-110 hover:text-white"
                          style={{
                            background: `linear-gradient(275.041deg, rgba(${primaryColorRgb}, 0.7) 7.25%, rgba(3, 51, 38, 0.8) 84.803%)`,
                            border: `1px solid ${primaryColor}`,
                            boxShadow: `0px 0px 15.9542px 0px rgba(3, 51, 38, 0.8)`,
                          }}
                        >
                          Okay
                        </Buttons>
                      </DialogTrigger>
                    </div>
                  </DialogContent>
                </Dialog>
              </div>
            </div>

            {/* Leadership Content */}
            <div className="flex flex-grow flex-col
items-center
justify-start
pt-20 sm:pt-[7rem]
">
              <div

                className="
 flex flex-col
    gap-2 lg:gap-5
      max-w-[60.875rem]
    lg:max-w-[74.875rem]
    w-full
   max-h-[78vh] 
    min-h-0
    overflow-hidden
    items-center
    justify-start
    rounded-[2.375rem]
    relative
    px-4 sm:px-6 lg:px-10
    py-4 sm:py-6

  "
                style={{
                  background: `linear-gradient(21deg, rgba(${primaryColorRgb}, 0.05) -10.76%, rgba(${primaryColorRgb}, 0.1) 127.18%)`,
                  padding: "25px"
                }}
              >
                {/* Leaderboard Title */}
                <div className="relative">
                  <h1
                    className="text-center text-2xl sm:text-3xl lg:text-4xl font-normal tracking-normal"
                    style={{
                      color: primaryColor,
                      textShadow: `rgba(${primaryColorRgb}, 0.5) 0px 0px 9px`,
                    }}
                  >
                    Leaderboard
                  </h1>
                </div>

                {/* Decorative Line */}
                <div className="relative flex w-full items-center justify-start">
                  <div className="w-full">
                    <div className="relative h-[1px] w-full">
                      <div
                        className="absolute inset-0"
                        style={{
                          background: `linear-gradient(90deg, transparent 0%, ${primaryColor} 48%, transparent 100%)`,
                          opacity: 0.995,
                        }}
                      />
                    </div>
                  </div>
                </div>

                {/* Tabs using ShadCN */}
                <div className="w-full flex flex-col h-full min-h-0">
                  <Tabs
                    value={selectedTab}
                    onValueChange={(value) =>
                      setSelectedTab(value as 'department' | 'overall')
                    }
                    className="w-full flex flex-col h-full"
                  >
                    <TabsList
                      className="
    grid w-full grid-cols-2
    gap-2 sm:gap-3
    bg-transparent p-0
  "
                      style={{
                        background: 'transparent',
                      }}
                    >
                      <TabsTrigger
                        value="overall"
                        className="font-rubik rounded-sm border px-3 py-3.5 text-xl font-medium tracking-[-0.048px] transition-all duration-200 hover:scale-[1.01] data-[state=active]:bg-transparent data-[state=active]:shadow-none"
                        style={{
                    borderWidth: '0.540px',
                          borderColor:
                            selectedTab === 'overall'
                              ? `rgba(${primaryColorRgb}, 0.5)`
                              : '#000000',
                          color:
                            selectedTab === 'overall'
                              ? primaryColor
                              : 'rgba(255,255,255,0.5)',
                          boxShadow: '0px 0px 12.485px 0px rgba(0,0,0,0.5)',
                          opacity: selectedTab === 'overall' ? 1 : 0.8,
                          background: `linear-gradient(21deg, rgba(${primaryColorRgb}, 0.02) -10.76%, rgba(${primaryColorRgb}, 0.1) 127.18%)`,
                        }}
                      >
                        Overall
                      </TabsTrigger>
                      <TabsTrigger
                        value="department"
                        className="font-rubik rounded-sm border px-3 py-3.5 text-xl font-medium tracking-[-0.048px] transition-all duration-200 hover:scale-[1.01] data-[state=active]:bg-transparent data-[state=active]:shadow-none"
                        style={{
                          borderWidth: '0.548px',
                          borderColor:
                            selectedTab === 'department'
                              ? `rgba(${primaryColorRgb}, 0.5)`
                              : '#000000',
                          color:
                            selectedTab === 'department'
                              ? primaryColor
                              : 'rgba(255,255,255,0.5)',
                          boxShadow: '0px 0px 12.485px 0px rgba(0,0,0,0.5)',
                          opacity:
                            selectedTab === 'department' && !isDepartmentEmpty
                              ? 1
                              : 0.5,
                          background: `linear-gradient(21deg, rgba(${primaryColorRgb}, 0.02) -10.76%, rgba(${primaryColorRgb}, 0.1) 127.18%)`,
                          cursor: isDepartmentEmpty ? 'not-allowed' : 'pointer',
                        }}
                        onClick={handleDepartmentClick}
                        disabled={isDepartmentEmpty}
                      >
                        Department
                      </TabsTrigger>
                    </TabsList>

                    <TabsContent value="overall" className="mt-4 w-full flex flex-col min-h-0" >
                      {/* Leaderboard Table using shadcn */}
                      <div
                        className="
    w-full
  "
                        ref={containerRef}
                      >
                        <div
                          className="box-border flex w-full flex-col content-stretch items-start justify-start overflow-clip rounded-md p-2"
                          style={{
                            backgroundImage:
                              'linear-gradient(90deg, rgba(0, 0, 0, 0.63) 0%, rgba(0, 0, 0, 0.63) 100%)',
                            backgroundSize: 'auto, cover',
                            backgroundPosition: '0% 0%, 50% 50%',
                          }}
                        >
                    <Table className="min-w-[540px] lg:min-w-[(800px,100%)] w-full table-fixed">
                      <colgroup>
                        <col className="w-[73px] lg:w-[180px]" />
                        <col className="w-[90px] sm:w-[110px] lg:w-[90px]" />
                        <col className="w-[110px] lg:w-[90px]" />
                        <col className="w-[110px] lg:w-[90px]" />
                        <col className="w-[110px] lg:w-[90px]" />
                      </colgroup>
                            <TableHeader>
                              <TableRow className="border-b-0 hover:bg-transparent">
                          <TableHead className="font-poppins h-[1.879rem] border-r border-[#3d3d3d] bg-[rgba(0,0,0,0.5)] text-center text-[11px] sm:text-sm font-semibold text-[#7f7d83]">
                            Player Name
                                </TableHead>
                                <TableHead
                                  className="font-poppins h-[1.879rem] border-r border-[#3d3d3d] bg-[rgba(0,0,0,0.5)] px-4 text-center text-[11px] sm:text-sm font-semibold text-[#7f7d83]"
                                  colSpan={2}
                                >
                                  Daily
                                </TableHead>
                                <TableHead
                                  className="font-poppins h-[1.879rem] bg-[rgba(0,0,0,0.5)] px-4 text-center text-[11px] sm:text-sm font-semibold text-[#7f7d83]"
                                  colSpan={2}
                                >
                                  All Time
                                </TableHead>
                              </TableRow>
                              <TableRow className="border-b-0 hover:bg-transparent">
                          <TableHead className="h-[1.879rem] border-r border-[#3d3d3d] bg-[rgba(0,0,0,0.5)]"></TableHead>
                          <TableHead className="font-poppins h-[1.879rem] border-r border-[#3d3d3d] bg-[rgba(0,0,0,0.5)] text-center text-[11px] sm:text-sm font-semibold text-[#7f7d83]">
                            Position
                          </TableHead>
                          <TableHead className="font-poppins h-[1.879rem] border-r border-[#3d3d3d] bg-[rgba(0,0,0,0.5)] text-center text-[11px] sm:text-sm font-semibold text-[#7f7d83]">
                            Score
                          </TableHead>
                          <TableHead className="font-poppins h-[1.879rem] border-r border-[#3d3d3d] bg-[rgba(0,0,0,0.5)] text-center text-[11px] sm:text-sm font-semibold text-[#7f7d83]">
                            Position
                          </TableHead>
                          <TableHead className="font-poppins h-[1.879rem] bg-[rgba(0,0,0,0.5)] text-center text-[11px] sm:text-sm font-semibold text-[#7f7d83]">
                            Score
                          </TableHead>
                        </TableRow>
                      </TableHeader>
                    </Table>
                    <div className="w-full
    overflow-y-auto
                          
                          " 
                          style={{
     maxHeight: "15rem",
  }} >
                      <Table className="min-w-[540px] lg:min-w-[(800px,100%)] w-full table-fixed">
                        <colgroup>
                          <col className="w-[73px] lg:w-[180px]" />
                          <col className="w-[90px] sm:w-[110px] lg:w-[90px]" />
                          <col className="w-[110px] lg:w-[90px]" />
                          <col className="w-[110px] lg:w-[90px]" />
                          <col className="w-[110px] lg:w-[90px]" />
                        </colgroup>
                              <TableBody>
                                {leaderboardToRender.map((player, index) => {
                                  const isUser =
                                    player.name ===
                                    (learnerPlayList?.LearnerProfile
                                      ?.nickName ??
                                      learnerPlayList?.LearnerProfile?.name);
                                  return (
                                    <TableRow
                                      key={index}
                                      className="h-[3.188rem] border-b"
                                      style={{
                                        borderBottomColor: isUser
                                          ? primaryColor
                                          : '#3d3d3d',
                                        borderBottomWidth: '0.751px',
                                        backgroundColor: isUser
                                          ? `rgba(${primaryColorRgb},0.15)`
                                          : '',
                                      }}
                                    >
                                      <TableCell
                                  className="font-rubik border-r border-[#3d3d3d] pl-[1.691rem] text-xs sm:text-[11px] sm:text-sm lg:text-base font-semibold tracking-[-0.0376px]"
                                        style={{
                                          color: isUser
                                            ? primaryColor
                                            : '#ffffff',
                                          borderRightColor: '#3d3d3d',
                                        }}
                                      >
                                        {player.name || 'Guest'}
                                      </TableCell>
                                      <TableCell
                                  className="font-rubik border-r border-[#3d3d3d] text-center text-xs sm:text-[11px] sm:text-sm lg:text-base font-semibold tracking-[-0.0376px]"
                                        style={{
                                          color: isUser
                                            ? primaryColor
                                            : '#ffffff',
                                          borderRightColor: '#3d3d3d',
                                        }}
                                      >
                                        {player.dailyPosition ?? index + 1}
                                      </TableCell>
                                      <TableCell
                                  className="font-rubik border-r border-[#3d3d3d] text-center text-xs sm:text-[11px] sm:text-sm lg:text-base font-semibold tracking-[-0.0376px]"
                                        style={{
                                          color: isUser
                                            ? primaryColor
                                            : '#ffffff',
                                          borderRightColor: '#3d3d3d',
                                        }}
                                      >
                                        {player.score ?? 0}
                                      </TableCell>
                                      <TableCell
                                  className="font-rubik border-r border-[#3d3d3d] text-center text-xs sm:text-[11px] sm:text-sm lg:text-base font-semibold tracking-[-0.0376px]"
                                        style={{
                                          color: isUser
                                            ? primaryColor
                                            : '#ffffff',
                                          borderRightColor: '#3d3d3d',
                                        }}
                                      >
                                        {player.alltimePosition ?? index + 1}
                                      </TableCell>
                                      <TableCell
                                  className="font-rubik text-center text-xs sm:text-[11px] sm:text-sm lg:text-base font-semibold tracking-[-0.0376px]"
                                        style={{
                                          color: isUser
                                            ? primaryColor
                                            : '#ffffff',
                                        }}
                                      >
                                        {player.allTimeScore ?? 0}
                                      </TableCell>
                                    </TableRow>
                                  );
                                })}
                              </TableBody>
                            </Table>
                          </div>
                        </div>
                      </div>
                    </TabsContent>

                    <TabsContent value="department" className="mt-4 w-full flex flex-col min-h-0">
                      {/* Department tab - same structure as overall */}
                      <div
                        className="
    w-full
  "
                        ref={containerRef}
                      >
                        <div
                          className="box-border flex w-full flex-col content-stretch items-start justify-start overflow-clip rounded-md p-2"
                          style={{
                            backgroundImage:
                              'linear-gradient(90deg, rgba(0, 0, 0, 0.63) 0%, rgba(0, 0, 0, 0.63) 100%)',
                            backgroundSize: 'auto, cover',
                            backgroundPosition: '0% 0%, 50% 50%',
                          }}
                        >
                    <Table className="min-w-[540px] lg:min-w-[(800px,100%)] w-full table-fixed">
                      <colgroup>
                        <col className="w-[73px] lg:w-[180px]" />
                        <col className="w-[90px] sm:w-[110px] lg:w-[90px]" />
                        <col className="w-[110px] lg:w-[90px]" />
                        <col className="w-[110px] lg:w-[90px]" />
                        <col className="w-[110px] lg:w-[90px]" />
                      </colgroup>
                            <TableHeader>
                              <TableRow className="border-b-0 hover:bg-transparent">
                          <TableHead className="font-poppins h-[1.879rem] border-r border-[#3d3d3d] bg-[rgba(0,0,0,0.5)] text-center text-[11px] sm:text-sm font-semibold text-[#7f7d83]">
                                  Player Name
                                </TableHead>
                                <TableHead
                                  className="font-poppins h-[1.879rem] border-r border-[#3d3d3d] bg-[rgba(0,0,0,0.5)] px-4 text-center text-[11px] sm:text-sm font-semibold text-[#7f7d83]"
                                  colSpan={2}
                                >
                                  Daily
                                </TableHead>
                                <TableHead
                                  className="font-poppins h-[1.879rem] bg-[rgba(0,0,0,0.5)] px-4 text-center text-[11px] sm:text-sm font-semibold text-[#7f7d83]"
                                  colSpan={2}
                                >
                                  All Time
                                </TableHead>
                              </TableRow>
                              <TableRow className="border-b-0 hover:bg-transparent">
                          <TableHead className="h-[1.879rem] border-r border-[#3d3d3d] bg-[rgba(0,0,0,0.5)]"></TableHead>
                          <TableHead className="font-poppins h-[1.879rem] border-r border-[#3d3d3d] bg-[rgba(0,0,0,0.5)] text-center text-[11px] sm:text-sm font-semibold text-[#7f7d83]">
                                  Position
                                </TableHead>
                          <TableHead className="font-poppins h-[1.879rem] border-r border-[#3d3d3d] bg-[rgba(0,0,0,0.5)] text-center text-[11px] sm:text-sm font-semibold text-[#7f7d83]">
                                  Score
                                </TableHead>
                          <TableHead className="font-poppins h-[1.879rem] border-r border-[#3d3d3d] bg-[rgba(0,0,0,0.5)] text-center text-[11px] sm:text-sm font-semibold text-[#7f7d83]">
                                  Position
                                </TableHead>
                          <TableHead className="font-poppins h-[1.879rem] bg-[rgba(0,0,0,0.5)] text-center text-[11px] sm:text-sm font-semibold text-[#7f7d83]">
                                  Score
                                </TableHead>
                              </TableRow>
                            </TableHeader>
                          </Table>
                          <div className=" w-full
    overflow-y-auto"
    style={{
     maxHeight: "15rem",
  }}
                    
                    >
                      <Table className="min-w-[540px] lg:min-w-[(800px,100%)] w-full table-fixed">
                        <colgroup>
                          <col className="w-[73px] lg:w-[180px]" />
                          <col className="w-[90px] sm:w-[110px] lg:w-[90px]" />
                          <col className="w-[110px] lg:w-[90px]" />
                          <col className="w-[110px] lg:w-[90px]" />
                          <col className="w-[110px] lg:w-[90px]" />
                        </colgroup>
                        <TableBody>
                          {leaderboardToRender.map((player, index) => {
                            const isUser =
                              player.name ===
                              (learnerPlayList?.LearnerProfile
                                ?.nickName ??
                                learnerPlayList?.LearnerProfile?.name);
                            return (
                              <TableRow
                                key={index}
                                className="h-[3.188rem] border-b"
                                style={{
                                  borderBottomColor: isUser
                                    ? primaryColor
                                    : '#3d3d3d',
                                  borderBottomWidth: '0.751px',
                                  backgroundColor: isUser
                                    ? `rgba(${primaryColorRgb},0.15)`
                                    : '',
                                }}
                              >
                                <TableCell
                                  className="font-rubik border-r border-[#3d3d3d] pl-[1.691rem] text-xs sm:text-[11px] sm:text-sm lg:text-base font-semibold tracking-[-0.0376px]"
                                  style={{
                                    color: isUser
                                      ? primaryColor
                                      : '#ffffff',
                                    borderRightColor: '#3d3d3d',
                                  }}
                                >
                                  {player.name || 'Guest'}
                                </TableCell>
                                <TableCell
                                  className="font-rubik border-r border-[#3d3d3d] text-center text-xs sm:text-[11px] sm:text-sm lg:text-base font-semibold tracking-[-0.0376px]"
                                  style={{
                                    color: isUser
                                      ? primaryColor
                                      : '#ffffff',
                                    borderRightColor: '#3d3d3d',
                                  }}
                                >
                                  {player.dailyPosition ?? index + 1}
                                </TableCell>
                                <TableCell
                                  className="font-rubik border-r border-[#3d3d3d] text-center text-xs sm:text-[11px] sm:text-sm lg:text-base font-semibold tracking-[-0.0376px]"
                                  style={{
                                    color: isUser
                                      ? primaryColor
                                      : '#ffffff',
                                    borderRightColor: '#3d3d3d',
                                  }}
                                >
                                  {player.score ?? 0}
                                </TableCell>
                                <TableCell
                                  className="font-rubik border-r border-[#3d3d3d] text-center text-xs sm:text-[11px] sm:text-sm lg:text-base font-semibold tracking-[-0.0376px]"
                                  style={{
                                    color: isUser
                                      ? primaryColor
                                      : '#ffffff',
                                    borderRightColor: '#3d3d3d',
                                  }}
                                >
                                  {player.alltimePosition ?? index + 1}
                                </TableCell>
                                <TableCell
                                  className="font-rubik text-center text-xs sm:text-[11px] sm:text-sm lg:text-base font-semibold tracking-[-0.0376px]"
                                  style={{
                                    color: isUser
                                      ? primaryColor
                                      : '#ffffff',
                                  }}
                                >
                                  {player.allTimeScore ?? 0}
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </div>
                  </div>
                </div>
              </TabsContent>
            </Tabs>
          </div>

                {/* Bottom Navigation */}
                <div className="mt-3 shrink-0 flex w-full items-center justify-between py-2">
                  <NavigationArrow
                    direction="left"
                    onClick={handleLeftNavigation}
                    primaryColor={primaryColor}
                  />
                  <NavigationArrow
                    direction="right"
                    onClick={() => handleNext()}
                    primaryColor={primaryColor}
                  />
                </div>

                {/* Inset Shadow Border */}
                <div
                  className="pointer-events-none absolute inset-0 rounded-[2.375rem]"
                  style={{
                    boxShadow: `0px 0px 11px 0px inset rgba(${primaryColorRgb}, 0.3), 0px 0px 20px 0px rgba(${primaryColorRgb}, 0.2)`,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </motion.div>
    );
  },
);

export default LeaderBoardFutureTheme;

